export default __webpack_public_path__ + "static/media/(35).1fb243ba.JPG";